
function initCustomSelectboxes(){

    //return true;

    // Iterate over each select element
    $('.select-style:not(.tomselect-style)').each(function () {

        var $select = $(this).find("select")

        // Cache the number of options
        var numberOfOptions = $select.children('option').length;

        // Hides the select element
        $select.addClass('s-hidden');

        // Wrap the select element in a div
        $select.wrap('<div class="select"></div>');

        // Insert a styled div to sit over the top of the hidden select element
        $select.after('<div class="styledSelect"></div>');

        // Cache the styled div
        var $styledSelect = $select.next('div.styledSelect');

        // Show the first select option in the styled div
        $styledSelect.text($select.children('option').eq(0).text());

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $select.children('option').eq(i).text(),
                rel: $select.children('option').eq(i).val()
            }).appendTo($list);
        }

        // Cache the list items
        var $listItems = $list.children('li');

        //handle change events
        $select.on("change", function(e){
            var selectedText = $(this).find("option:selected").text();
            $styledSelect.text(selectedText);
            $styledSelect.removeClass('active');
            $list.hide();
            $(this).trigger("blur"); //remove focus
            var $parent = $(this).parent(".select");
            if($(this).val() != "" && !$parent.hasClass("selected")){
                $parent.addClass("selected");
            }
        });

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $select.val($(this).attr('rel'));
            var $parent = $select.parent(".select");
            if($(this).attr('rel') != "" && !$parent.hasClass("selected")){
                $parent.addClass("selected");
            }
            $list.hide();
            //console.log("listItems " + $(this).attr('rel'));
            $select.trigger("change");
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });
	
    updateCustomSelectboxes();
}


function updateCustomSelectboxes(){

    // Iterate over each select element
    $('.select-style:not(.tomselect-style)').each(function () {

        var $select = $(this).find(".select");
        var $label = $(this).find("label");

        $select.css("min-height", $label.outerHeight());
    });
}
